import { useRouter } from 'next/router';
import React from 'react';

import ListPageStates from '@/src/shared/components/ListPage/ListPageStates';
import useListSearch from '@/src/shared/hooks/useListSearch';
import states from '@/utils/states';

import { ABOUT_ACCESS, checkAccess } from '@/src/shared/constants';
import { useSelector } from 'react-redux';
import Error from '@/pages/_error';

const searchOptions = {
  pubCode: 416,
};

const LitigationBulletin = props => {
  const { statecode } = props;
  const router = useRouter();
  const _statecode = statecode || router.query.slug || 0;
  const [loading, results] = useListSearch(searchOptions, _statecode);

  const { role, isLoggedIn } = useSelector(state => state.auth);
  const PersonID = useSelector(state => state.auth.userinfo.PersonID);

  const hasAccess = checkAccess(ABOUT_ACCESS.MEMBERSHIP, role);
  const isAuthorized = PersonID && Array.isArray(role) && hasAccess;
  const errorCode = isLoggedIn && !hasAccess ? 401.4 : 401;
  
  if (!isLoggedIn || !isAuthorized) return <Error status={errorCode} />;

  return (
    <ListPageStates
      title="Litigation Bulletin"
      heroContent={null}
      results={results}
      truncateResultSummary
      searchOptions={searchOptions}
      statecode={_statecode}
      loading={loading}
      titlePrefix=""
      routeBase="/advocacy/legal-judicial-advocacy/litigation-bulletin"
    />
  );
};

export async function getStaticPaths() {
  return {
    paths: states.map(s => ({ params: { slug: s.StateCode } })),
    fallback: false,
  };
}

export async function getStaticProps({ params }) {
  return {
    props: {
      statecode: params.slug || 0,
    },
  };
}

export default LitigationBulletin;
